"use strict";
/**
 * created by ma.rongqin 2017-3-3
 * 媒立方上传视频至吉木萨尔县在线后的操作服务
 */
angular.module('uploadToZjolServiceModule', [])
    .factory('uploadToZjolService', ['$q', 'httpServer', '$sce', '$http',
        function($q, httpServer, $sce, $http) {
            var allowPlayTime = 60 * 60 * 1000; //视频允许播放的时间1小时
            var key = "5rWZ5rGf6KeG55WM5aqS56uL5pa5"; //用于各处加密的key
            var currUserInfo;
            getCurrUserInfo();
            /**
             * [getCurrUserInfo description]获取当前用户信息
             */
            function getCurrUserInfo() {
                var params = {
                    'serviceid': "mlf_extuser",
                    'methodname': "getCurrUserInfo",
                };
                httpServer.http(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    currUserInfo = data;
                });
            };
            /**
             * [getServiceTime description]获取当前服务器时间
             */
            function getServiceTime(addTime) {
                var defer = $q.defer();
                var params = {
                    'serviceid': "mlf_fusion",
                    'methodname': "getServiceTime",
                };
                httpServer.http(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    var time = String(new Date(data.LASTOPERTIME).getTime() + addTime);
                    defer.resolve(time);
                });
                return defer.promise;
            };
            /**
             * [encodeSign description]加密
             */
            function encodeSign(str) {
                var defer = $q.defer();
                var key = "5rWZ5rGf6KeG55WM5aqS56uL5pa5";
                var encodeParams = {
                    serviceid: 'mlf_metadata',
                    methodname: 'encode',
                    pwd: str
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), encodeParams, 'get').then(function(data) {
                    var afterEncode = data.key.replace(/"/g, '');
                    defer.resolve(afterEncode);
                })
                return defer.promise;
            };
            return {
                getVideoUrl: function(id) {
                    // var defer = $q.defer();
                    // var url = "http://m.v.zjol.com.cn/a/mlf/player.shtml";
                    // url += ('?id=' + id);
                    // getServiceTime(allowPlayTime).then(function(time) {
                    //     time = Math.round(time / 1000);
                    //     url += ('&time=' + time);
                    //     id = Number(id);
                    //     return encodeSign(id + time + key);
                    // }).then(function(sign) {
                    //     url += ('&sign=' + sign);
                    //     defer.resolve($sce.trustAsResourceUrl(url));
                    // });
                    // return defer.promise;
                    var defer = $q.defer();
                    encodeSign(id + key).then(function(afterEncode) {
                        var params = {
                            id: id,
                            token: afterEncode
                        }
                        trsHttpService.httpServer('/a/mlf/download.shtml', params, 'get').then(function(data) {
                            // defer.resolve($sce.trustAsResourceUrl(data.url.replace(/"/g,'')));
                            defer.resolve($sce.trustAsResourceUrl(data.playUrl));
                        });
                    });
                    return defer.promise;
                },
                queryStatus: function(id, success, wait, fault, cancel) {
                    trsHttpService.httpServer('/a/mlf/getVideoStatus.shtml', { id: id }, 'get').then(function(data) {
                        if (data.code == '0') {
                            success(data.id);
                        } else if (data.code == '1' || data.code == '2') {
                            wait(data.id);
                        } else if (data.code == '3' || data.code == '4') {
                            fault(data.id);
                        } else if (data.code == 5) {
                            if (angular.isFunction(cancel)) {
                                cancel(data.id);
                            }
                        };
                    });
                },
                downloadVideo: function(id) {
                    var defer = $q.defer();
                    encodeSign(id + key).then(function(afterEncode) {
                        var params = {
                            id: id,
                            token: afterEncode
                        }
                        trsHttpService.httpServer('/a/mlf/download.shtml.shtml', params, 'get').then(function(data) {
                            // defer.resolve($sce.trustAsResourceUrl(data.url.replace(/"/g,'')));
                            defer.resolve(data);
                        });
                    });
                    return defer.promise;
                },
                newdownloadVideo: function(id) {
                    var defer = $q.defer();
                    encodeSign(id + key).then(function(afterEncode) {
                        var params = {
                            id: id,
                            token: afterEncode
                        }
                        trsHttpService.httpServer('http://m.v.zjol.com.cn/a/mlf/download.shtml.shtml', params, 'get').then(function(data) {
                            defer.resolve(data);
                        });
                    });
                    return defer.promise;
                },
                saveVideo: function(params) {
                    var defer = $q.defer();
                    params.userId = currUserInfo.ID;
                    encodeSign(Number(params.id) + params.name + Number(params.docId) + Number(params.userId) + key).then(function(afterEncode) {
                        params.sign = afterEncode;
                        trsHttpService.httpServer('/a/mlf/saveVideoInfo.shtml', params, 'post').then(function(data) {
                            defer.resolve(data);
                        })
                    });
                    return defer.promise;
                },
                // editVideo: function(params) {
                //     var defer = $q.defer();
                //     params.userId = currUserInfo.ID;
                //     encodeSign(Number(params.docId) + params.videoIds + params.userId + key).then(function(afterEncode) {
                //         params.sign = afterEncode;
                //         trsHttpService.httpServer('/a/mlf/createEditVideo.shtml', params, 'post').then(function(data) {
                //             defer.resolve(data);
                //         })
                //     });
                //     return defer.promise;
                // },
                // queryEditStatus: function(id, success, wait, cancel,transcoding) {
                //     trsHttpService.httpServer('/a/mlf/getVideoEditInfo.shtml', { id: id }, 'get').then(function(data) {
                //         if (data.status == 1) {
                //             success(data.new_id);
                //         } else if (data.status == 0) {
                //             wait(id);
                //         } else if (data.status == 2) {
                //             cancel();
                //         } else if(data.status==3){
                //             transcoding(id);
                //         }
                //     });
                // },

            }
        }
    ])
